import React from 'react';
import '../template-file-css/document-file-template.css';


export const LCS_RehabMemberChoice = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LCS_RehabMemberChoice' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>Chief Concern:</span>
                    <textarea id='txtChiefConcern' name='txtChiefConcern' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Present Illness:</span> <span className="small">
                        (Onset, Duration, Frequency of Symptoms, Previous Episodes, etc.)</span>
                    <textarea id="txtPresentIllness" name="txtPresentIllness" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>HISTORY OF SYMPTOMS: BEHAVIORAL/EMOTIONAL STATUS (INDIVIDUAL)</span>
                    <span className='small'>Please check all of following that is typical:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsAggressive" name="cbSymptomsAggressive" className='add-only' value="Aggressive" /> Aggressive</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsFrustratedEasily" name="cbSymptomsFrustratedEasily" className='add-only' value="FrustratedEasily" /> Frustrated easily</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSadCrying" name="cbSymptomsSadCrying" className='add-only' value="SadCrying" /> Sad/Crying</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsTruancy" name="cbSymptomsTruancy" className='add-only' value="Truancy" /> Truancy</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsMoodSwings" name="cbSymptomsMoodSwings" className='add-only' value="MoodSwings" /> Mood Swings</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsAngry" name="cbSymptomsAngry" className='add-only' value="Angry" /> Angry</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsAnxiety" name="cbSymptomsAnxiety" className='add-only' value="Anxiety" /> Anxiety</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsHallucinations" name="cbSymptomsHallucinations" className='add-only' value="Hallucinations" /> Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsHeadBanging" name="cbSymptomsHeadBanging" className='add-only' value="HeadBanging" /> Head banging  </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsFearful" name="cbSymptomsFearful" className='add-only' value="Fearful" /> Fearful</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsPtsd" name="cbSymptomsPtsd" className='add-only' value="Ptsd" /> PTSD</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsLiesFrequently" name="cbSymptomsLiesFrequently" className='add-only' value="LiesFrequently" /> Lies frequently</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSetFires" name="cbSymptomsSetFires" className='add-only' value="SetFires" /> Set fires </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsHurtsAnimals" name="cbSymptomsHurtsAnimals" className='add-only' value="HurtsAnimals" /> Hurts animals</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsAvoidsAdults" name="cbSymptomsAvoidsAdults" className='add-only' value="AvoidsAdults" /> Avoids adults</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsLoner" name="cbSymptomsLoner" className='add-only' value="Loner" /> Loner</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsImaginaryFriends" name="cbSymptomsImaginaryFriends" className='add-only' value="ImaginaryFriends" /> Imaginary friends</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSexualActingOut" name="cbSymptomsSexualActingOut" className='add-only' value="SexualActingOut" /> Sexual acting out</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsBedwetting" name="cbSymptomsBedwetting" className='add-only' value="Bedwetting" /> Bedwetting</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsImpulsive" name="cbSymptomsImpulsive" className='add-only' value="Impulsive" /> Impulsive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsShortAttentionSpan" name="cbSymptomsShortAttentionSpan" className='add-only' value="ShortAttentionSpan" /> Short attention span</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsBizarreBehavior" name="cbSymptomsBizarreBehavior" className='add-only' value="BizarreBehavior" /> Bizarre behavior</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsIrritable" name="cbSymptomsIrritable" className='add-only' value="Irritable" /> Irritable</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsRunningAway" name="cbSymptomsRunningAway" className='add-only' value="RunningAway" /> Running Away</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsHygieneAdls" name="cbSymptomsHygieneAdls" className='add-only' value="HygieneAdls" /> Hygiene/ADLs   </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSpeechProblems" name="cbSymptomsSpeechProblems" className='add-only' value="SpeechProblems" /> Speech problems</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsCarelessReckless" name="cbSymptomsCarelessReckless" className='add-only' value="CarelessReckless" /> Careless, reckless</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsBulliesThreatens" name="cbSymptomsBulliesThreatens" className='add-only' value="BulliesThreatens" /> Bullies, threatens </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsLearningProblems" name="cbSymptomsLearningProblems" className='add-only' value="LearningProblems" /> Learning problems  </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSteals" name="cbSymptomsSteals" className='add-only' value="Steals" /> Steals</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsSuicidalThreats" name="cbSymptomsSuicidalThreats" className='add-only' value="SuicidalThreats" /> Suicidal threats</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsLowSelfEsteem" name="cbSymptomsLowSelfEsteem" className='add-only' value="LowSelfEsteem" /> Low self-esteem </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsHyperactivity" name="cbSymptomsHyperactivity" className='add-only' value="Hyperactivity" />  Hyperactivity </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsTalksBack" name="cbSymptomsTalksBack" className='add-only' value="TalksBack" /> Talks back</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsImpulseControl" name="cbSymptomsImpulseControl" className='add-only' value="ImpulseControl" /> Impulse Control</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsNightmares" name="cbSymptomsNightmares" className='add-only' value="Nightmares" /> Nightmares </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsDefiant" name="cbSymptomsDefiant" className='add-only' value="Defiant" />  Defiant </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsDestructive" name="cbSymptomsDestructive" className='add-only' value="Destructive" /> Destructive</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsOppositional" name="cbSymptomsOppositional" className='add-only' value="Oppositional" /> Oppositional</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsPanicAttacks" name="cbSymptomsPanicAttacks" className='add-only' value="PanicAttacks" /> Panic attacks </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsDrugsDependence" name="cbSymptomsDrugsDependence" className='add-only' value="DrugsDependence" />  Drugs dependence </td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsPhobias" name="cbSymptomsPhobias" className='add-only' value="Phobias" /> Phobias</td>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsLossOfEnergyInterests" name="cbSymptomsLossOfEnergyInterests" className='add-only' value="LossOfEnergyInterests" /> Loss of Energy/Interests</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSymptomsOtherConcerns" name="cbSymptomsOtherConcerns" className='add-only' value="OtherConcerns" /> Other Concerns (specify): </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id="txtOther" name="txtOther" className='add-only'></textarea>
                </p>
                <p>
                    <h3>MEDICATION HISTORY:</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMedicationHistoryNoneReported" name="cbMedicationHistoryNoneReported" className='add-only' value="NoneReported" /> None reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>MEDICATION</span></td>
                        <td className='w-187'><span className='eleHeader'>DOSAGE</span></td>
                        <td className='w-187'><span className='eleHeader'>DATE START/ LAST USE</span></td>
                        <td className='w-187'><span className='eleHeader'>COMPLIANT</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_1" name="txtMedication_1" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_1" name="txtDosage_1" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_1" name="txtDateStart_1" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_1" name="txtCompliant_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id='"rbRxSource_1_Ex"' name="rbRxSource_1" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_1_In" name="rbRxSource_1" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_2" name="txtMedication_2" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_2" name="txtDosage_2" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_2" name="txtDateStart_2" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_2" name="txtCompliant_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_2_Ex" name="rbRxSource_2" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_2_In" name="rbRxSource_2" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_3" name="txtMedication_3" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_3" name="txtDosage_3" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_3" name="txtDateStart_3" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_3" name="txtCompliant_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_3_Ex" name="rbRxSource_3" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_3_In" name="rbRxSource_3" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_4" name="txtMedication_4" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_4" name="txtDosage_4" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_4" name="txtDateStart_4" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_4" name="txtCompliant_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_4_Ex" name="rbRxSource_4" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_4_In" name="rbRxSource_4" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_5" name="txtMedication_5" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_5" name="txtDosage_5" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_5" name="txtDateStart_5" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_5" name="txtCompliant_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_5_Ex" name="rbRxSource_5" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_5_In" name="rbRxSource_5" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_6" name="txtMedication_6" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_6" name="txtDosage_6" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_6" name="txtDateStart_6" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_6" name="txtCompliant_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_6_Ex" name="rbRxSource_6" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_6_In" name="rbRxSource_6" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_7" name="txtMedication_7" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_7" name="txtDosage_7" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_7" name="txtDateStart_7" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_7" name="txtCompliant_7" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_7_Ex" name="rbRxSource_7" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_7_In" name="rbRxSource_7" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_8" name="txtMedication_8" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_8" name="txtDosage_8" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_8" name="txtDateStart_8" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_8_Ex" name="rbRxSource_8" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_8_In" name="rbRxSource_8" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_9" name="txtMedication_9" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_9" name="txtDosage_9" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_9" name="txtDateStart_9" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_9" name="txtCompliant_9" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_9_Ex" name="rbRxSource_9" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_9_In" name="rbRxSource_9" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                    <tr>
                        <td className='w-187'><input type="text" id="txtMedication_10" name="txtMedication_10" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtDosage_10" name="txtDosage_10" className='add-only' /></td>
                        <td className='w-187'><input type="date" id="txtDateStart_10" name="txtDateStart_10" className='add-only' /></td>
                        <td className='w-187'><input type="text" id="txtCompliant_10" name="txtCompliant_10" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Prescription Prescribed By:&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_10_Ex" name="rbRxSource_10" className='add-only' value="ex" />&nbsp;&nbsp;
                            External Doctor &nbsp;&nbsp;
                            <span>-- OR --</span>&nbsp;&nbsp;
                            <input type="radio" id="rbRxSource_10_In" name="rbRxSource_10" className='add-only' value="in" />&nbsp;&nbsp;
                            Internal Doctor
                        </td>
                    </tr >
                </table >

                <p className='w-750'>
                    <span className='eleHeader'>Assessment:</span> <span className='small'>(Strengths,
                        Assets, Formulation)</span>
                    <textarea id="txtAssessment" name="txtAssessment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>EVALUATION OF RISK TO SELF OR OTHERS:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span><b>History of Suicidal/Homicidal Risk: </b></span>
                            <input type="checkbox" id="cbHomicidalRisk" name="cbHomicidalRisk" className='add-only' value="None reported" /> None reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_1" name="cbHomicidalRisk_1" className='add-only' value="Suicidal Ideation" /> Suicidal Ideation </td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_2" name="cbHomicidalRisk_2" className='add-only' value="Suicidal Attempt" /> Suicidal Attempt </td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_3" name="cbHomicidalRisk_3" className='add-only' value="Suicidal Threats" /> Suicidal Threats</td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_4" name="cbHomicidalRisk_4" className='add-only' value="Self Injurious Behavior" /> Self Injurious Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbHomicidalRisk_5" name="cbHomicidalRisk_5" className='add-only' value="History of Serious Physical Harm to Self" /> History of Serious Physical Harm to Self </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe history of risk behaviors: </span>
                    <textarea id="txtRiskBehaviors" name="txtRiskBehaviors" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_6" name="cbHomicidalRisk_6" className='add-only' value="HomicidalIdeation" /> Homicidal Ideation </td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_7" name="cbHomicidalRisk_7" className='add-only' value="HomicidalAttempts" /> Homicidal Attempts </td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_8" name="cbHomicidalRisk_8" className='add-only' value="HomicidalThreats" /> Homicidal Threats</td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_9" name="cbHomicidalRisk_9" className='add-only' value="SeriousLethalIntent" /> Serious Lethal Intent</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbHomicidalRisk_10" name="cbHomicidalRisk_10" className='add-only' value="History of Serious Physical Harm to others While in Treatment" /> History of Serious Physical Harm to others While in Treatment</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe history of risk behaviors: </span>
                    <textarea id="txtDescribeHistory" name="txtDescribeHistory" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_11" name="cbHomicidalRisk_11" className='add-only' value="PersistentRepetitive" /> Persistent/Repetitive&nbsp;&nbsp; </td>
                        <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_12" name="cbHomicidalRisk_12" className='add-only' value="HasPlan" /> Has a Plan &nbsp;&nbsp;</td>
                        <td className='w-250'><input type="checkbox" id="cbHomicidalRisk_13" name="cbHomicidalRisk_13" className='add-only' value="DelusionalPsychoticInContent" /> Delusional/Psychotic in Content</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Summary of Risk Evaluation:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'> <b> Suicidal Risk is:</b></td>
                        <td className='w-600'>
                            <input type="radio" id="rbSuicidal_Low" name="rbSuicidal" className='add-only' value="LowToNone" /> Low to None&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbSuicidal_Moderate" name="rbSuicidal" className='add-only' value="Moderate" /> Moderate&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbSuicidal_Imminent" name="rbSuicidal" className='add-only' value="Imminent" /> Imminent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b> Homicidal Risk is:</b> </td>
                        <td className='w-600'>
                            <input type="radio" id="rbHomicidal_Low" name="rbHomicidal" className='add-only' value="LowToNone" /> Low to None&nbsp;&nbsp;
                            <input type="radio" id="rbHomicidal_Moderate" name="rbHomicidal" className='add-only' value="Moderate" /> Moderate&nbsp;&nbsp;
                            <input type="radio" id="rbHomicidal_Imminent" name="rbHomicidal" className='add-only' value="Imminent" /> Imminent
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Plan for Work Up and Treatment:</span> <span className='small'>
                        (Rx's, Services, Drug Screens, Standing Orders, etc.)</span>
                    <textarea id="txtWorkUpTreatment" name="txtWorkUpTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>BEHAVIOR OBSERVATIONS: (FACE-TO-FACE)</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mental Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_1" name="cbMentalStatus_1" className='add-only' value="Alert" /> Alert&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_2" name="cbMentalStatus_2" className='add-only' value="OrientedTo" /> Oriented to:&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_3" name="cbMentalStatus_3" className='add-only' value="Person" /> Person
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_4" name="cbMentalStatus_4" className='add-only' value="Alert" /> Alert&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_5" name="cbMentalStatus_5" className='add-only' value="OrientedTo" /> Oriented to:&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMentalStatus_6" name="cbMentalStatus_6" className='add-only' value="Person" /> Person
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="NeatWellGroomed" /> Neat/Well Groomed&nbsp;&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Disheveled" /> Disheveled&nbsp;&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Bizarre" /> Bizarre
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className='add-only' value="Casual" /> Casual&nbsp;&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_5" name="cbAppearance_5" className='add-only' value="AgeAppropriate" /> Age Appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hygiene: </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbHygiene_Good" name="rbHygiene" className='add-only' value="Good" /> Good&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbHygiene_Fair" name="rbHygiene" className='add-only' value="Fair" /> Fair&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbHygiene_Poor" name="rbHygiene" className='add-only' value="Poor" /> Poor
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Posture:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbPostureRelaxed" name="cbPostureRelaxed" className='add-only' value="Relaxed" /> Relaxed </td>
                        <td className='w-187'><input type="checkbox" id="cbPostureErect" name="cbPostureErect" className='add-only' value="Erect" /> Erect </td>
                        <td className='w-187'><input type="checkbox" id="cbPostureSlouched" name="cbPostureSlouched" className='add-only' value="Slouched" /> Slouched</td>
                        <td className='w-187'><input type="checkbox" id="cbPosturePacing" name="cbPosturePacing" className='add-only' value="Pacing" /> Pacing</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eye Contact:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbEyeContactAppropriatePoor" name="cbEyeContactAppropriatePoor" className='add-only' value="Appropriate" /> Appropriate </td>
                        <td className='w-187'><input type="checkbox" id="cbEyeContactAppropriatePoor" name="cbEyeContactAppropriatePoor" className='add-only' value="Poor" /> Poor </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Primary Facial Expression:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbPrimaryFacialAppropriate" name="cbPrimaryFacialAppropriate" className='add-only' value="Appropriate" /> Appropriate </td>
                        <td className='w-187'><input type="checkbox" id="cbPrimaryFacialSad" name="cbPrimaryFacialSad" className='add-only' value="Sad" /> Sad </td>
                        <td className='w-187'><input type="checkbox" id="cbPrimaryFacialHappy" name="cbPrimaryFacialHappy" className='add-only' value="Happy" /> Happy</td>
                        <td className='w-187'><input type="checkbox" id="cbPrimaryFacialElated" name="cbPrimaryFacialElated" className='add-only' value="Elated" /> Elated</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbPrimaryFacialWorried" name="cbPrimaryFacialWorried" className='add-only' value="Worried" /> Worried</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAffectCalm" name="cbAffectCalm" className='add-only' value="Calm" /> Calm </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectOptimistic" name="cbAffectOptimistic" className='add-only' value="Optimistic" /> Optimistic  </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectCheerful" name="cbAffectCheerful" className='add-only' value="Cheerful" /> Cheerful</td>
                        <td className='w-187'><input type="checkbox" id="cbAffectAnxious" name="cbAffectAnxious" className='add-only' value="Anxious" /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAffectPessimistic" name="cbAffectPessimistic" className='add-only' value="Pessimistic" /> Pessimistic </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectFearful" name="cbAffectFearful" className='add-only' value="Fearful" /> Fearful  </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectNeutral" name="cbAffectNeutral" className='add-only' value="Neutral" /> Neutral</td>
                        <td className='w-187'><input type="checkbox" id="cbAffectBlunted" name="cbAffectBlunted" className='add-only' value="Blunted" /> Blunted</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAffectDepressed" name="cbAffectDepressed" className='add-only' value="Depressed" /> Depressed </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectTearful" name="cbAffectTearful" className='add-only' value="Tearful" /> Tearful </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectIrritable" name="cbAffectIrritable" className='add-only' value="Irritable" /> Irritable</td>
                        <td className='w-187'><input type="checkbox" id="cbAffectFlat" name="cbAffectFlat" className='add-only' value="Flat" /> Flat</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAffectAngry" name="cbAffectAngry" className='add-only' value="Angry" /> Angry </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectEuphoric" name="cbAffectEuphoric" className='add-only' value="Euphoric" /> Euphoric </td>
                        <td className='w-187'><input type="checkbox" id="cbAffectElated" name="cbAffectElated" className='add-only' value="Elated" /> Elated</td>
                        <td className='w-187'><input type="checkbox" id="cbAffectLabile" name="cbAffectLabile" className='add-only' value="Labile" /> Labile</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbJudgmentGood" name="rbJudgment" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbJudgmentFair" name="rbJudgment" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbJudgmentPoor" name="rbJudgment" className='add-only' value="Poor" /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightGood" name="rbInsight" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightFair" name="rbInsight" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightPoor" name="rbInsight" className='add-only' value="Poor" /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Memory:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span>Recent:</span>
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRecentGood" name="rbRecent" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRecentFair" name="rbRecent" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRecentPoor" name="rbRecent" className='add-only' value="Poor" /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span>Remote:</span>
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRemoteGood" name="rbRemote" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRemoteFair" name="rbRemote" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbRemotePoor" name="rbRemote" className='add-only' value="Poor" /> Poor
                        </td>
                    </tr>
                </table>

                <h4>Diagnosis</h4>
                <table>
                    <tr>
                        <td className='w-20'><span className='eleHeader'>#</span></td>
                        <td className='w-500'><span className='eleHeader'>Diagnosis</span></td>
                        <td className='w-230'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td>(1)</td>
                        <td className='w-500'><input type="text" id="txtDiagnosis_1" name="txtDiagnosis_1" className='add-only' /></td>
                        <td className='w-230'><input type='text' id="txtDate_1" name="txtDate_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>(2)</td>
                        <td className='w-500'><input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' /></td>
                        <td className='w-230'><input type='text' id="txtDate_2" name="txtDate_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>(3)</td>
                        <td className='w-500'><input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' /></td>
                        <td className='w-230'><input type='text' id="txtDate_3" name="txtDate_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>(4)</td>
                        <td className='w-500'><input type="text" id="txtDiagnosis_4" name="txtDiagnosis_4" className='add-only' /></td>
                        <td className='w-230'><input type='text' id="txtDate_4" name="txtDate_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>(5)</td>
                        <td className='w-500'><input type="text" id="txtDiagnosis_5" name="txtDiagnosis_5" className='add-only' /></td>
                        <td className='w-230'><input type='text' id="txtDate_5" name="txtDate_5" className='add-only' /></td>
                    </tr>
                </table>



            </div >
        </form >

    )
}











